// This is just an example,
// so you can safely delete all default props below

export default {
    back: 'Back',
    users: 'Users',
    create: 'Create',
    email: 'Email',
    name: 'Name',
    roles: 'Roles',
}
